import { computed, ref } from 'vue'
import { defineStore } from 'pinia'

type AiComplianceDialogState = 'checking' | 'open' | 'idle'

/** Coordinates proactive post-login dialogs so they never compete for focus. */
export const useProactiveDialogsStore = defineStore('proactiveDialogs', () => {
  const aiComplianceState = ref<AiComplianceDialogState>('checking')

  const blocksPasskeyEnrollment = computed(() => aiComplianceState.value !== 'idle')

  function beginAiComplianceCheck(): void {
    aiComplianceState.value = 'checking'
  }

  function showAiCompliance(): void {
    aiComplianceState.value = 'open'
  }

  function finishAiCompliance(): void {
    aiComplianceState.value = 'idle'
  }

  function reset(): void {
    aiComplianceState.value = 'checking'
  }

  return {
    aiComplianceState,
    beginAiComplianceCheck,
    blocksPasskeyEnrollment,
    finishAiCompliance,
    reset,
    showAiCompliance,
  }
})
